export default "__VITE_ASSET__f782c692__"